export const MOVEMENT_TYPES = ['inbound', 'outbound', 'reservation', 'release', 'adjustment'] as const;
export type MovementType = (typeof MOVEMENT_TYPES)[number];

export interface AdminBalance {
  id: string;
  variantId: string;
  warehouseId: string;
  quantityOnHand: number;
  quantityReserved: number;
  quantityAvailable: number | null;
  lowStockThreshold: number;
  version: number;
  updatedAt: string;
  productName: string;
  variantName: string;
  sku: string;
  warehouseCode: string;
}

export interface AdminMovement {
  id: number;
  variantId: string;
  warehouseId: string;
  movementType: string;
  quantityDelta: number;
  balanceAfterOnHand: number;
  balanceAfterReserved: number;
  reasonId: number | null;
  referenceType: string | null;
  referenceId: string | null;
  note: string | null;
  createdBy: string | null;
  createdAt: string;
  productName: string;
  variantName: string;
  sku: string;
  warehouseCode: string;
}

export interface AdminWarehouse {
  id: string;
  code: string;
  name: string;
  addressLine1: string | null;
  city: string | null;
  state: string | null;
  pincode: string | null;
  isActive: boolean;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface BalancesListParams {
  warehouseId?: string;
  stockStatus?: 'low' | 'out';
  search?: string;
  limit?: number;
  offset?: number;
}

export interface MovementsListParams {
  variantId?: string;
  warehouseId?: string;
  movementType?: MovementType;
  sku?: string;
  dateFrom?: string;
  dateTo?: string;
  limit?: number;
  offset?: number;
}

export interface AdjustStockInput {
  variantId: string;
  warehouseId: string;
  movementType: MovementType;
  quantity: number;
  reasonId?: number | null;
  note?: string | null;
  referenceType?: string | null;
  referenceId?: string | null;
}
